export default "__VITE_ASSET__zqLyVOYD__"